import React, { FC, ReactNode } from 'react';
import { useTheme } from '../../../hooks/useTheme';
import styles from './PanelHeader.module.css';

export interface PanelHeaderProps {
  children: ReactNode;
}

const PanelHeader: FC<PanelHeaderProps> = ({ children }) => {
  const { panelheaderNoneNone: panelHeaderStyle } = useTheme();

  return (
    <h2 className={styles.panelHeader} style={panelHeaderStyle}>
      {children}
    </h2>
  );
};

export default PanelHeader;
